// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ClaimV1ClaimClaimV1ClaimAccumulatorByMemberNumberAccumulatorByMemberNumberRequest {
    'memberNumber': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClaimV1ClaimClaimV1ClaimAccumulatorByMemberNumberAccumulatorByMemberNumberRequest>> = [
        {
            "name":     "memberNumber",
            "baseName": "memberNumber",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return ClaimV1ClaimClaimV1ClaimAccumulatorByMemberNumberAccumulatorByMemberNumberRequest.attributeTypeMap;
    }
}
